import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Menu,
    MenuItem,
    Box,
    Typography,
    Avatar,
    IconButton,
    Divider,
    Button
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { signOut } from 'firebase/auth';
import { auth, db } from '../firebase-config';
import { doc, onSnapshot } from 'firebase/firestore';
import ThemeToggleSwitch from './ThemeToggleSwitch';

const UserProfileMenu = ({ anchorEl, open, onClose, user, isDarkMode, toggleTheme }) => {
    const navigate = useNavigate();

    useEffect(() => {
        const handleNavigationChange = () => {
            localStorage.removeItem('pendingConversation');
        };

        window.addEventListener('popstate', handleNavigationChange);
        window.addEventListener('beforeunload', handleNavigationChange);

        return () => {
            window.removeEventListener('popstate', handleNavigationChange);
            window.removeEventListener('beforeunload', handleNavigationChange);
            handleNavigationChange();
        };
    }, []);

    const handleSignOut = async () => {
        try {
            await signOut(auth);
            onClose();
            navigate('/');
        } catch (error) {
            console.error("Error signing out:", error);
        }
    };

    return (
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            PaperProps={{
                elevation: 3,
                sx: {
                    width: 320,
                    mt: 1.5,
                    padding: 2,
                    borderRadius: 2,
                }
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
            <Box sx={{ position: 'relative', pb: 2 }}>
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: -8,
                        top: -8,
                    }}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
                
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Avatar 
                        src={user?.photoURL}
                        alt={user?.displayName}
                        sx={{ width: 60, height: 60, mr: 2 }}
                    />
                    <Box>
                        <Typography variant="subtitle1">{user?.displayName}</Typography>
                        <Typography variant="body2" color="text.secondary">
                            {user?.email}
                        </Typography>
                    </Box>
                </Box>

                <Divider />

                <Box sx={{ py: 2 }}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        mb: 2
                    }}>
                        <Typography variant="subtitle2">
                            Theme
                        </Typography>
                        <ThemeToggleSwitch isDarkMode={isDarkMode} toggleTheme={toggleTheme} />
                    </Box>
                    <Divider sx={{ my: 2 }} />
                    <Button
                        fullWidth
                        variant="outlined"
                        color="inherit"
                        onClick={handleSignOut}
                        sx={{
                            borderRadius: 1,
                            textTransform: 'none'
                        }}
                    >
                        Sign Out
                    </Button>
                </Box>
            </Box>
        </Menu>
    );
};

export default UserProfileMenu;
